import { useTranslation } from "react-i18next";
import { Check } from "lucide-react";

const BookingProgress = ({ step }) => {
  const { t } = useTranslation();

  const labels = [
    t("booking.steps.eventDetails"),
    t("booking.steps.contactInfo"),
    t("booking.steps.review"),
  ];

  return (
    <div className="bg-white py-6 shadow-sm sticky top-16 z-40">
      <div className="max-w-3xl mx-auto px-6">
        <div className="flex items-start justify-center">
          {[1, 2, 3].map((s) => (
            <div key={`step-${s}`} className="flex items-center">
              <div className="flex flex-col items-center">
                <div
                  className={`w-10 h-10 rounded-full flex items-center justify-center font-semibold transition-colors ${
                    step >= s
                      ? "bg-[#E07A5F] text-white"
                      : "bg-gray-200 text-gray-500"
                  }`}
                  data-testid={`step-indicator-${s}`}
                >
                  {step > s ? <Check className="w-5 h-5" /> : s}
                </div>
                <span className={`mt-2 text-sm text-center ${step >= s ? "text-[#E07A5F]" : "text-gray-400"}`}>
                  {labels[s - 1]}
                </span>
              </div>
              {s < 3 && (
                <div
                  className={`w-16 md:w-24 h-1 mx-2 mt-5 rounded self-start ${
                    step > s ? "bg-[#E07A5F]" : "bg-gray-200"
                  }`}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BookingProgress;
